<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h2>Please tell us who you are</h2>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>
                  It will help us give you the best deal (within stipulated legal considerations.)
                </h3>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>
                  For this study, I declare myself:
                </h3>
              </div>
            </div>
          </div>
          <div>
            <form class="pure-form pure-form-stacked" @submit.prevent="handleSubmit" novalidate>
              <fieldset>
                <div class="regular radio-row">
                  <div class="bigmi-checkbox">
                    <div>
                      <input id="regular" type="radio" value="regular" v-model="selectedValue">
                    </div>
                    <div>
                      <label for="regular">
                        <span class="label-text">REGULAR USER: A regular user (individual, company, organization, etc), wanting the results to be mine alone (privatized), and not available to anyone else. If you have an access/coupon code, you will be use at the time of payment.</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="student radio-row">
                  <div class="bigmi-checkbox">
                    <div>
                      <input id="student" type="radio" value="student" v-model="selectedValue">
                    </div>
                    <div>
                      <label for="student">
                        <span class="label-text">STUDENT: A student matriculated in school or recent graduate, using this study for my own use, with no funding from any other source but myself.</span>
                      </label>
                    </div>
                  </div>
                </div>
                <button type="submit" class="hidden-submit"></button>
                <div v-if="showErrorMessage" style="color: red">
                  * One of the above selections is required
                </div>
              </fieldset>
              <BigStudyNavigation @touched="onTouched"></BigStudyNavigation>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
    import {GET_NEXT_STUDY_STEP_ROUTE, SET_TELL_US_WHO_YOU_ARE} from "../../services/constants"
    import {mapGetters} from "vuex"

    export default {
        name: "TellUsWhoYouAre",

        data(){
            return {
                selectedValue: "",
                submitTouched: false,
            }
        },

        computed: {
            ...mapGetters([
                GET_NEXT_STUDY_STEP_ROUTE,
            ]),
            isFormModelValid(){
                return this.selectedValue !== ""
            },
            showErrorMessage() {
              return this.submitTouched && this.selectedValue.length < 1
            }
        },

        methods: {
            onTouched() {
                this.submitTouched = true
            },
            handleSubmit() {
                if (this.isFormModelValid) {
                    this.$store.commit(SET_TELL_US_WHO_YOU_ARE, this.selectedValue)
                    this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE])
                }
            },
        }
    }
</script>

<style scoped lang="scss">
  @import "../../scss/main";

  .container {
    height: 100%;
  }

  section {
    height: 100%;
  }

  .layout {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
  }

  .child {
    width: 100%;
    max-width: 500px;
    margin: 1em;
  }

  h2 {
    text-align: center;
    color: $red-2;
  }

  h3 {
    color: $cyan-blue-3;
  }

  .pure-form input[type="text"] {
    box-shadow: none;
    width: 100%;
    color: $cyan-blue-3;
    border-color: $cyan-blue-3;

    &:focus {
      border-color: $cyan-blue-1;
    }
    &:placeholder-shown {
      color: $gray-3;
    }
    &:-ms-input-placeholder {
      color: $gray-3;
    }
  }

  .question-title {
    font-size: 0.83em;
    font-weight: bold;
    color: $cyan-blue-3;
  }

  .invalid {
    color: $red-2;
  }

  .radio-row {
    margin: 1em 0 0 0;
  }

  .label-text {
    font-size: 16px;
  }
</style>
